export const toAbsoluteUrl = (pathname: string) => 'https://olivebranchdubai.com' + pathname
